import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Collapse, Button, CardBody, Card } from 'reactstrap';
import Research from "../data/research.json"

export class DailyMarket extends Component {
    constructor(props) {
        super(props);
        this.toggle = this.toggle.bind(this);
        this.state = { collapse: true };
    }

    toggle() {
        this.setState(state => ({ collapse: !state.collapse }));
        document.getElementById('faWealthMan').classList.toggle('rotateFAOpen');
        document.getElementById('hrWealthMan').classList.toggle('d-none');
    }


    render() {
        return (
            <div>
                <Button className='collapseBTN' color="link" onClick={this.toggle} style={{ marginBottom: '1rem' }}>Daily Market Valuation and Price Mobility<i className={"fa fa-chevron-up"} aria-hidden="true" id='faWealthMan'></i></Button>
                <hr className='collapseHr d-none' id='hrWealthMan' />
                <Collapse isOpen={this.state.collapse}>
                    <DailyPrice />
                    <MarketWrap />
                    <PriceList />
                </Collapse>
            </div>
        );
    }
}

export class DailyPrice extends Component {
    constructor(props) {
        super(props);
        this.toggle = this.toggle.bind(this);
        this.state = { collapse: false };
    }

    toggle() {
        this.setState(state => ({ collapse: !state.collapse }));
        document.getElementById('faInflation').classList.toggle('rotateFA');
        document.getElementById('hrInflation').classList.toggle('d-none');
    }

    render() {
        return (
            <div>
                <Button className='collapseBTN' color="link" onClick={this.toggle} style={{ marginBottom: '1rem', marginLeft: '1.5rem' }}>Daily market report on Nigeria and other emerging markets<i className={"fa fa-chevron-down"} aria-hidden="true" id='faInflation'></i></Button>
                <hr className='collapseHr' id='hrInflation' />
                <Collapse isOpen={this.state.collapse}>
                    <Card>
                        <CardBody>
                            <div className='row'>
                                {Research.InflationWatch.map(doc => {
                                    return (
                                        <div className='col-4 col-sm-3  col-xl-2 res-doc' key={doc.id}>
                                            <Link to={doc.link}>
                                                <div className='tiny-card'>
                                                    <div className='tiny-card-body'>
                                                        <div className='tiny-card-text'>
                                                            <p className='bold text-decoration-none'>{doc.title}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Link>
                                        </div>
                                    )
                                })}
                            </div>
                        </CardBody>
                    </Card>
                </Collapse>
            </div>
        );
    }
}


export class MarketWrap extends Component {
    constructor(props) {
        super(props);
        this.toggle = this.toggle.bind(this);
        this.state = { collapse: false };
    }

    toggle() {
        this.setState(state => ({ collapse: !state.collapse }));
        document.getElementById('faInflation').classList.toggle('rotateFA');
        document.getElementById('hrInflation').classList.toggle('d-none');
    }

    render() {
        return (
            <div>
                <Button className='collapseBTN' color="link" onClick={this.toggle} style={{ marginBottom: '1rem', marginLeft: '1.5rem' }}>Market Wrap<i className={"fa fa-chevron-down"} aria-hidden="true" id='faInflation'></i></Button>
                <hr className='collapseHr' id='hrInflation' />
                <Collapse isOpen={this.state.collapse}>
                    <Card>
                        <CardBody>
                            <div className='row'>
                                {Research.InflationWatch.map(doc => {
                                    return (
                                        <div className='col-4 col-sm-3  col-xl-2 res-doc' key={doc.id}>
                                            <Link to={doc.link}>
                                                <div className='tiny-card'>
                                                    <div className='tiny-card-body'>
                                                        <div className='tiny-card-text'>
                                                            <p className='bold text-decoration-none'>{doc.title}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Link>
                                        </div>
                                    )
                                })}
                            </div>
                        </CardBody>
                    </Card>
                </Collapse>
            </div>
        );
    }
}


export class PriceList extends Component {
    constructor(props) {
        super(props);
        this.toggle = this.toggle.bind(this);
        this.state = { collapse: false };
    }

    toggle() {
        this.setState(state => ({ collapse: !state.collapse }));
        document.getElementById('faInflation').classList.toggle('rotateFA');
        document.getElementById('hrInflation').classList.toggle('d-none');
    }

    render() {
        return (
            <div>
                <Button className='collapseBTN' color="link" onClick={this.toggle} style={{ marginBottom: '1rem', marginLeft: '1.5rem' }}>Price List<i className={"fa fa-chevron-down"} aria-hidden="true" id='faInflation'></i></Button>
                <hr className='collapseHr' id='hrInflation' />
                <Collapse isOpen={this.state.collapse}>
                    <Card>
                        <CardBody>
                            <div className='row'>
                                {Research.InflationWatch.map(doc => {
                                    return (
                                        <div className='col-4 col-sm-3  col-xl-2 res-doc' key={doc.id}>
                                            <Link to={doc.link}>
                                                <div className='tiny-card'>
                                                    <div className='tiny-card-body'>
                                                        <div className='tiny-card-text'>
                                                            <p className='bold text-decoration-none'>{doc.title}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Link>
                                        </div>
                                    )
                                })}
                            </div>
                        </CardBody>
                    </Card>
                </Collapse>
            </div>
        );
    }
}

export class Macroeconomic extends Component {
    constructor(props) {
        super(props);
        this.toggle = this.toggle.bind(this);
        this.state = { collapse: false };
    }

    toggle() {
        this.setState(state => ({ collapse: !state.collapse }));
        document.getElementById('faEconomic').classList.toggle('rotateFA');
        document.getElementById('hrEconomic').classList.toggle('d-none');
    }

    render() {
        return (
            <div>
                <Button className='collapseBTN' color="link" onClick={this.toggle} style={{ marginBottom: '1rem' }}>Macroeconomic Report<i className={"fa fa-chevron-down"} aria-hidden="true" id='faEconomic'></i></Button>
                <hr className='collapseHr' id='hrEconomic' />
                <Collapse isOpen={this.state.collapse}>
                    <Card>
                        <CardBody>
                            <div className='row'>
                                {Research.Economic.map(doc => {
                                    return (
                                        <div className='col-4 col-sm-3  col-xl-2 res-doc' key={doc.id}>
                                            <Link to={doc.link}>
                                                <div className='tiny-card'>
                                                    <div className='tiny-card-body'>
                                                        <div className='tiny-card-text'>
                                                            <p className='bold text-decoration-none'>{doc.title}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Link>
                                        </div>
                                    )
                                })}
                            </div>
                        </CardBody>
                    </Card>
                </Collapse>
            </div>
        );
    }
}


export class Indicator extends Component {
    constructor(props) {
        super(props);
        this.toggle = this.toggle.bind(this);
        this.state = { collapse: false };
    }

    toggle() {
        this.setState(state => ({ collapse: !state.collapse }));
        document.getElementById('faEconomic').classList.toggle('rotateFA');
        document.getElementById('hrEconomic').classList.toggle('d-none');
    }

    render() {
        return (
            <div>
                <Button className='collapseBTN' color="link" onClick={this.toggle} style={{ marginBottom: '1rem' }}>Macroeconomic Indicators<i className={"fa fa-chevron-down"} aria-hidden="true" id='faEconomic'></i></Button>
                <hr className='collapseHr' id='hrEconomic' />
                <Collapse isOpen={this.state.collapse}>
                    <Card>
                        <CardBody>
                            <div className='row'>
                                {Research.Economic.map(doc => {
                                    return (
                                        <div className='col-4 col-sm-3  col-xl-2 res-doc' key={doc.id}>
                                            <Link to={doc.link}>
                                                <div className='tiny-card'>
                                                    <div className='tiny-card-body'>
                                                        <div className='tiny-card-text'>
                                                            <p className='bold text-decoration-none'>{doc.title}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Link>
                                        </div>
                                    )
                                })}
                            </div>
                        </CardBody>
                    </Card>
                </Collapse>
            </div>
        );
    }
}

export class Equity extends Component {
    constructor(props) {
        super(props);
        this.toggle = this.toggle.bind(this);
        this.state = { collapse: false };
    }

    toggle() {
        this.setState(state => ({ collapse: !state.collapse }));
        document.getElementById('faMPC').classList.toggle('rotateFA');
        document.getElementById('hrMPC').classList.toggle('d-none');
    }

    render() {
        return (
            <div>
                <Button className='collapseBTN' color="link" onClick={this.toggle} style={{ marginBottom: '1rem' }}>Equity Research Notes<i className={"fa fa-chevron-down"} aria-hidden="true" id='faMPC'></i></Button>
                <hr className='collapseHr' id='hrMPC' />
                <Collapse isOpen={this.state.collapse}>
                    <Card>
                        <CardBody>
                            <div className='row'>
                                {Research.EquityResearch.map(doc => {
                                    return (
                                        <div className='col-4 col-sm-3  col-xl-2 res-doc' key={doc.id}>
                                            <Link to={doc.link}>
                                                <div className='tiny-card'>
                                                    <div className='tiny-card-body'>
                                                        <div className='tiny-card-text'>
                                                            <p className='bold text-decoration-none'>{doc.title}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Link>
                                        </div>
                                    )
                                })}
                            </div>
                        </CardBody>
                    </Card>
                </Collapse>
            </div>
        );
    }
}


export class Sector extends Component {
    constructor(props) {
        super(props);
        this.toggle = this.toggle.bind(this);
        this.state = { collapse: false };
    }

    toggle() {
        this.setState(state => ({ collapse: !state.collapse }));
        document.getElementById('faMPC').classList.toggle('rotateFA');
        document.getElementById('hrMPC').classList.toggle('d-none');
    }

    render() {
        return (
            <div>
                <Button className='collapseBTN' color="link" onClick={this.toggle} style={{ marginBottom: '1rem' }}>Sector Research<i className={"fa fa-chevron-down"} aria-hidden="true" id='faMPC'></i></Button>
                <hr className='collapseHr' id='hrMPC' />
                <Collapse isOpen={this.state.collapse}>
                    <Card>
                        <CardBody>
                            <div className='row'>
                                {Research.MPC.map(doc => {
                                    return (
                                        <div className='col-4 col-sm-3  col-xl-2 res-doc' key={doc.id}>
                                            <Link to={doc.link}>
                                                <div className='tiny-card'>
                                                    <div className='tiny-card-body'>
                                                        <div className='tiny-card-text'>
                                                            <p className='bold text-decoration-none'>{doc.title}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Link>
                                        </div>
                                    )
                                })}
                            </div>
                        </CardBody>
                    </Card>
                </Collapse>
            </div>
        );
    }
}

export class Bespoke extends Component {
    constructor(props) {
        super(props);
        this.toggle = this.toggle.bind(this);
        this.state = { collapse: false, passed: false };
    }

    toggle() {
        this.setState(state => ({ collapse: !state.collapse }));
        document.getElementById('faEquity').classList.toggle('rotateFA');
        document.getElementById('hrEquity').classList.toggle('d-none');
    }

    render() {
        return (
            <div>
                <Button className='collapseBTN' color="link" onClick={this.toggle} style={{ marginBottom: '1rem' }}>Bespoke Reports<i className={"fa fa-chevron-down"} aria-hidden="true" id='faEquity'></i></Button>
                <hr className='collapseHr' id='hrEquity' />
                <Collapse isOpen={this.state.collapse}>
                    <Card>
                        <CardBody>
                                <div className='row'>
                                    {Research.EquityResearch.map(doc => {
                                        return (
                                            <div className='col-4 col-sm-3  col-xl-2 res-doc' key={doc.id}>
                                                <Link to={doc.link}>
                                                    <div className='tiny-card'>
                                                        <div className='tiny-card-body'>
                                                            <div className='tiny-card-text'>
                                                                <p className='bold text-decoration-none'>{doc.title}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Link>
                                            </div>
                                        )
                                    })}
                                </div>
                        </CardBody>
                    </Card>
                </Collapse>
            </div>
        );
    }
}



export class Archives extends Component {
    constructor(props) {
        super(props);
        this.toggle = this.toggle.bind(this);
        this.state = { collapse: false };
    }

    toggle() {
        this.setState(state => ({ collapse: !state.collapse }));
        document.getElementById('faMPC').classList.toggle('rotateFA');
        document.getElementById('hrMPC').classList.toggle('d-none');
    }

    render() {
        return (
            <div>
                <Button className='collapseBTN' color="link" onClick={this.toggle} style={{ marginBottom: '1rem' }}>Archives<i className={"fa fa-chevron-down"} aria-hidden="true" id='faMPC'></i></Button>
                <hr className='collapseHr' id='hrMPC' />
                <Collapse isOpen={this.state.collapse}>
                    <Card>
                        <CardBody>
                            <div className='row'>
                                {Research.EquityResearch.map(doc => {
                                    return (
                                        <div className='col-4 col-sm-3  col-xl-2 res-doc' key={doc.id}>
                                            <Link to={doc.link}>
                                                <div className='tiny-card'>
                                                    <div className='tiny-card-body'>
                                                        <div className='tiny-card-text'>
                                                            <p className='bold text-decoration-none'>{doc.title}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Link>
                                        </div>
                                    )
                                })}
                            </div>
                        </CardBody>
                    </Card>
                </Collapse>
            </div>
        );
    }
}